<template>
  <section class="py-5 container">
    <div class="row gap-3">
      <div
        class="col-6 col-md-3 rounded-3 text-center py-4 mb-4 shadow-lg"
        :class="module.inverted ? 'bg-dark' : 'bg-light'"
        v-for="module in modules"
        :key="module.name"
      >
        <router-link :to="{ name: module.name }">
          <div
            class="d-flex flex-column align-items-center"
            :class="module.inverted ? 'text-white' : 'text-dark'"
          >
            <i :class="module.icon + ' ri-3x'"></i>
            <span class="fw-bold text-lg">{{ module.title }}</span>
          </div>
        </router-link>
        <router-view />
      </div>
    </div>
  </section>
</template>

<script setup>
const modules = [
  {
    title: "Nueva cotización",
    icon: "ri-add-line",
    name: "factoraje-cotizacion-nueva",
    inverted: true,
  },
  {
    title: "Mis cotizaciones",
    icon: "ri-list-radio",
    name: "factoraje-cotizacion-historial",
    inverted: false,
  },
];
</script>
